import { Navigation } from "@/components/NavigationContext"
import Head from "next/head"
import Link from "next/link"
import { useContext, useEffect } from "react"

const Projects = ({ content, navigation, projects }) => {
    const { setNavigationItems } = useContext(Navigation)

    useEffect(() => {
        if (navigation) {
            setNavigationItems(navigation)
        }
    }, [navigation])

    return (
        <>
            <Head>
                <title>Projects | Studio Rinsma</title>
                <meta name="description" content="Here you'll find my recent projects." />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <div className="page-projects">
                <header>
                    <div className="global-wrapper">
                        <h1>
                            <span className="heading-js-wrapper">
                                <span style={{ animationDelay: '.2s' }} dangerouslySetInnerHTML={{ __html: content.header.title }} />
                            </span>
                        </h1>
                    </div>
                </header>

                <section className="projects">
                    <div className="projects-wrapper">
                        {projects.data.map((project, index) => (
                            <div className="project" key={index}>
                                <Link href={`/project/${project.slug}`}>
                                    <div className="global-wrapper">
                                        <div className="project-inner">
                                            <span className="counter">{((index + 1) < 10) ? `0${index + 1}` : `${index + 1}`}</span>

                                            <div className="project-info">
                                                <span className="project-title">{project.title}</span>
                                                <span className="project-type">{project.categories.slice(0, 2).join(' & ')}</span>
                                            </div>

                                            <div className="link-wrapper">
                                                <span>View project</span>
                                                <i className="fas fa-arrow-right-long" />
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="cta-wrapper">
                    <div className="global-wrapper">
                        <Link href={`/${content.cta.link}`} className="cta-inner">
                            <div className="cta-content">
                                <span className="cta-title">{content.cta.title}</span>
                                <span className="cta-subtext">{content.cta.subtext}</span>
                            </div>

                            <div className="cta-link-wrapper">
                                <i className="fas fa-arrow-right-long" />
                            </div>
                        </Link>
                    </div>
                </section>
            </div>
        </>
    )
}

export default Projects

export async function getServerSideProps() {
    const res = await fetch(`${process.env.API_URL}/page/projects.json`)
    const content = await res.json()

    const navigationRes = await fetch(`${process.env.API_URL}/api/globals.json`)
    const navigation = await navigationRes.json()

    const projectsRes = await fetch(`${process.env.API_URL}/api/projects.json`)
    const projects = await projectsRes.json()

    return {
        props: {
            content,
            navigation,
            projects,
        }
    }
}